module.exports = "<div id=wrapper><nav id=header-nav class=\"navbar navbar-default navbar-static-top\" role=navigation><span compile=::appController.header><div class=navbar-header><a href=# ng-click=appController.displayHome() class=navbar-brand>{{ ::appController.applicationName }}</a></div></span><ma-menu-bar menu=::appController.menu></ma-menu-bar></nav><div id=page-wrapper><div ui-view></div></div><div id=loader></div></div>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/javascripts/ng-admin/Main/view/layout.html
 ** module id = 161
 ** module chunks = 0 1
 **/